import Vue from 'vue'
import VueRouter from 'vue-router'
import { buyerRoutes } from './buyer'
import { techProviderRoutes } from './tech-provider'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue'),
    children: [
      ...buyerRoutes,
      ...techProviderRoutes,
      {
        path: '',
        name: 'companies',
        component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue'),
        redirect: {
          name: 'company-explore'
        },
        children: [
          {
            path: '/explore',
            name: 'company-explore',
            component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue')
          },
          {
            path: '/category',
            name: 'company-categories',
            component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue')
          },
          {
            path: '/category/:cat',
            name: 'company-category',
            component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue')
          },
          {
            path: '/category/:cat/:firstcat',
            name: 'company-category-first',
            component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue')
          },
          {
            path: '/category/:cat/:firstcat/:secondcat',
            name: 'company-category-second',
            component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue')
          }
        ]
      },
      {
        path: '/tech-provider/:slug',
        name: 'company',
        component: () => import(/* webpackChunkName: "company-detail-page" */ '../components/companies/CompanyDetailsPage.vue')
      }
    ]
  },
  {
    path: '/404-page-not-found',
    component: () => import(/* webpackChunkName: "page-not-found" */ '../views/PageNotFound.vue'),
    name: '404-page-not-found'
  },
  {
    path: '/approved-registration/:email',
    name: 'approved-registration',
    component: () => import(/* webpackChunkName: "register-status" */ '../views/ApprovedRegistration.vue')
  },
  {
    path: '/rfp-confirmation/:rfpNumber',
    name: 'rfp-review-status',
    component: () => import(/* webpackChunkName: "register-status" */ '../components/rfp-list/RfpReviewStatus.vue')
  },
  {
    path: '/reset-password/:user',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "register-status" */ '../components/auth/ResetPassword.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
